/**
 * Composable for managing application view mode
 * Provides reactive state and methods for controlling the current view
 */
import { ref } from 'vue';

/**
 * Create a view mode management composable
 * 
 * @returns {Object} - View mode state and methods
 */
export function useViewMode() {
  // Current view mode
  const viewMode = ref('scene');
  
  /**
   * Set the current view mode
   * 
   * @param {string} mode - The view mode to set
   * @param {Array} avatars - Optional user avatars array to check limit for 'init' mode
   */
  const setViewMode = (mode, avatars = []) => {
    // Only allow init mode if user doesn't have too many avatars
    if (mode === 'init' && avatars.length > 2) {
      console.log('Not allowed to create more avatars (limit reached)');
      return;
    }
    
    viewMode.value = mode;
  };
  
  return {
    viewMode,
    setViewMode
  };
}